module.exports = __webpack_public_path__ + "static/img/no_image.9cd92179.png";